import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context'
import { onError } from 'apollo-link-error'
import ApolloClient from 'apollo-client'
import queryString from 'query-string'
import { HttpLink } from 'apollo-boost'

const DEV_DOMAIN = 'api.spaceiq.dev'
const PROD_DOMAIN = 'api.spaceiq.com'

export function setCookie(name, value = '', days) {
  let expires = ''
  if (days) {
    const date = new Date()
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
    expires = '; expires=' + date.toUTCString()
  }
  let domain = ''
  if (window.ENV === 'production') domain = '; domain=.spaceiq.com'

  document.cookie = `${name}=${value}${expires}${domain}; Secure; path=/`
}

export function getCookie(name) {
  const nameEQ = name + '='
  const ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return ''
}

function getApiUrl(origin) {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL
  if (origin.match(/apollo/)) return origin.replace(/apollo/, 'api')
  return 'http://localhost:3001'
}

const queryStringResult = queryString.parse(window.location.search)
let { origin, hostname } = queryStringResult

hostname = hostname || window.location.hostname
origin = origin || window.location.origin

window.graphqlEndpoint = queryStringResult.graphqlEndpoint || getApiUrl(origin)

if (process.env.REACT_APP_VERSION) window.APP_VERSION = process.env.REACT_APP_VERSION

const tkn = window.localStorage.getItem(`access_token-${hostname}`)

const localStorageToken = tkn ? tkn : ''
const cookieToken = getCookie(`access_token-${hostname}`)

export const accessToken = cookieToken || localStorageToken

export function clearToken() {
  window.localStorage.setItem(`access_token-${hostname}`, '')
  setCookie(`access_token-${hostname}`, '', -1)
}

const queryRegex = /^(query|mutation)/

const fetchGraphqlQuery = (queryParams, options) => {
  const graphqlEndpoint = window.graphqlEndpoint
  try {
    const url = new URL(graphqlEndpoint)
    if (!(url.origin.includes(DEV_DOMAIN) || url.origin.includes(PROD_DOMAIN))) {
      throw new Error('Invalid or untrusted API endpoint.')
    }
    const sanitizedQueryParams = encodeURIComponent(queryParams)
    const fullUrl = `${graphqlEndpoint}/queries?${decodeURIComponent(sanitizedQueryParams)}`
    return fetch(fullUrl, options)
  } catch (error) {
    console.error('Fetch failed:', error.message)
    throw error
  }
}

const customFetch = (uri, options) => {
  const { operationName, query } = JSON.parse(options.body)
  const type = queryRegex.exec(query) || []
  const queryParams = type.length > 0 && operationName ? `?${type[0]}:${operationName}` : ''
  return fetchGraphqlQuery(queryParams, options)
}

const httpLink = new HttpLink({ fetch: customFetch })

const cache = new InMemoryCache()
const resetToken = onError(({ networkError }) => {
  if (accessToken && networkError && networkError.statusCode === 401) {
    clearToken()
    window.location.reload()
  }
})
const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  // return the headers to the context so httpLink can read them

  return {
    headers: {
      ...headers,
      Authorization: accessToken ? `Bearer ${accessToken}` : '',
      WebRequest: true,
    },
  }
}).concat(resetToken)

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'network-only',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const client = {
  gql: new ApolloClient({
    link: authLink.concat(httpLink),
    cache,
    defaultOptions,
  }),
}
export function initTestClient(mockClient) {
  client.gql = mockClient
}

export default client
